<template>
  <div class="pro-inside" v-loading="loading">
    <div class="container">
      <h2>- {{title}} -</h2>
      <div class="floor-box-1 pc-nr">
        <img :src="mainPicSrc" alt="">
        <div class="floor-right">
          <strong class="hidden-xs-only">{{title}}</strong>
          <p class="desc-content">{{description}}</p>
        </div>
      </div>

      <div class="pro-list">
        <div
            v-for="(item, index) in productList"
            :key="index"
            class="product-item"
        >
          <a @click="handleProductItemClick(item.id)">
            <img :src="item.url + item.thumbnailSrc" alt="">
            <h3 class="nowrap">{{item.name}}</h3>
            <p>{{item.description}}</p>
            <!-- 该span改为流式展示，不再定位 -->
            <span class="product-count">共有<em>{{item.children.length}}</em>款产品</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getProductClassifyById } from "@/api/home";

export default {
  data() {
    return {
      loading: false,
      title: '',
      description: '',
      mainPicSrc: '',
      productList: [],
      productId: '',
    }
  },
  watch: {
    "$route.query.productId": {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.productId = newVal;
          this.getProductDetailById(newVal);
        } else {
          this.$message.warning("产品ID不能为空");
        }
      },
    },
  },
  methods: {
    async getProductDetailById(productId) {
      try {
        this.loading = true;
        const res = await getProductClassifyById(productId);
        if (res.code === 200) {
          const data = res.data[0];
          this.title = data.name;
          this.description = data.description;
          this.mainPicSrc = data.url + data.thumbnailSrc;
          this.productList = data.children || [];
        } else {
          this.$message.error(res.msg || "获取产品详情失败");
        }
      } catch (error) {
        console.error("产品详情请求失败：", error);
        this.$message.error("网络异常，请稍后重试");
      } finally {
        this.loading = false;
      }
    },
    handleProductItemClick(id) {
      this.$router.push({
        path: "/third_cl",
        query: {
          parentId: this.productId,
          childrenId: id
        }
      });
    }
  },
}
</script>

<style scoped lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.pro-inside {
  background: url('../../../assets/img/product/gray_bg.jpg') 0 0 no-repeat;
  background-size: 100% 100%;
  margin-top: 100px;
  width: 100%;
  overflow-x: hidden;

  @media (max-width: 768px) {
    margin-top: 50px;
    width: 100vw;
  }
}

.container {
  position: relative;
  max-width: 1600px;
  margin: 0 auto;
  width: 100%;

  @media (max-width: 768px) {
    padding: 0 10px;
    max-width: 100%;
  }
}

.pro-inside h2 {
  line-height: 120px;
  font-size: 22px;
  text-align: center;
  animation: downIn 0.8s 0.2s both;

  @media (max-width: 768px) {
    line-height: 60px;
    font-size: 18px;
  }
}

.floor-box-1 {
  position: relative;
  background: #fff;
  width: 100%;

  img {
    width: 62.5%;
    display: block;

    @media (max-width: 768px) {
      width: 100%;
    }
  }

  .floor-right {
    position: absolute;
    top: 0;
    right: 0;
    width: 37.5%;
    height: 100%;
    padding: 0 3%;
    background: #fff;

    strong {
      display: block;
      margin: 10% auto;
      font-size: 26px;
      color: #d55c5c;
    }

    .desc-content {
      height: 500px;
      margin-top: -20px;
      line-height: 22px;
      color: #666;
      overflow: hidden;
    }

    @media (max-width: 768px) {
      position: static;
      width: 100%;
      height: auto;
      padding: 15px;

      strong {
        margin: 15px 0;
        font-size: 20px;
        text-align: center;
      }

      .desc-content {
        height: auto;
        margin-top: 0;
        font-size: 14px;
        line-height: 24px;
        padding-bottom: 10px;
      }
    }
  }
}

.pro-list {
  overflow: hidden;
  padding-top: 20px;
  padding-bottom: 5%;
  width: 100%;

  .product-item {
    float: left;
    width: 25%;
    margin-top: 30px;
    padding: 0 1%;
    overflow: hidden;
  }

  @media (max-width: 768px) {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-top: 15px;
    padding-bottom: 20px;

    .product-item {
      float: none;
      width: 48%;
      margin-top: 15px;
      padding: 0;
      max-width: none;
      p{
        font-size: 12px;
        line-height: 18px;
        max-height: 80px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3; /* 限制显示的行数为3 */
        overflow: hidden;
      }
    }
  }
}

.product-item {
  a {
    position: relative;
    display: block;
    // 移除原有的padding-bottom（为绝对定位span预留的空间）
    // padding-bottom: 40px;
    padding: 10px; // 仅保留内边距，适配流式布局
    background: #fff;
    width: 100%;
    height: 100%;
    text-decoration: none;
    color: #333;

    img {
      max-height: 100%;
      max-width: 100%;
      display: block;
      border: none;
      margin: 0 auto;
    }
  }

  h3 {
    margin: 10px 0;
    padding: 0 15px;
    font-size: 18px;
    color: #d55c5c;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    @media (max-width: 768px) {
      font-size: 12px;
      margin: 8px 0;
      padding: 0 8px;
    }
  }

  p {
    height: 70px;
    padding: 0 15px;
    color: #666;
    line-height: 22px;
    overflow: hidden;

    @media (max-width: 768px) {
      height: auto;
      max-height: 60px;
      font-size: 14px;
      padding: 0 8px;
      line-height: 20px;
    }
  }

  // 核心修改：产品数量提示的样式（流式展示）
  .product-count {
    // 移除所有绝对定位相关样式
    // position: absolute;
    // bottom: -40px;
    // left: 0;
    display: block; // 保持块级展示
    width: 100%;
    height: auto; // 取消固定高度，自适应内容
    line-height: 24px; // 适配行高
    padding: 8px 15px; // 内边距替代固定高度
    margin-top: 8px; // 与描述文本拉开间距
    color: #666;
    background: rgba(239, 239, 239, .8);
    // 移除hover动画（无需再动）
    // transition: all 0.3s;

    @media (max-width: 768px) {
      padding: 6px 8px;
      font-size: 14px;
      line-height: 20px;
    }
  }

  em {
    color: #d55c5c;
  }

  // 移除hover时的span动画（无需再动）
  // &:hover span {
  //   bottom: 0;
  // }
}

@keyframes downIn {
  0% {
    transform: translateY(-50px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

@-webkit-keyframes downIn {
  0% {
    -webkit-transform: translateY(-50px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateY(0);
    opacity: 1;
  }
}
</style>